"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

var _FaICIconMap = require("./../../../FaICIconMap");

var _Modifiers = require("./../../utils/Modifiers");

var _FooterImages = require("./FooterImages");

var _EditorContext = require("../../../EditorContext");

var _Constants = _interopRequireDefault(require("./../../../Constants"));

require("./../../containers/CommonBlockContainer.css");

require("./FooterContainer.css");

var _excluded = ["block", "className", "theme"],
    _excluded2 = ["blockProps", "customStyleMap", "customStyleFn", "decorator", "forceSelection", "offsetKey", "selection", "tree", "contentState", "blockStyleFn"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FOOTER = _Constants["default"].ENTITY_TYPES.FOOTER;

var FooterContainer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FooterContainer, _Component);

  function FooterContainer() {
    var _this;

    _this = _Component.call(this) || this;
    _this.state = {
      showConfirmDelete: false
    };
    _this._showEdit = _this._showEdit.bind(_assertThisInitialized(_this));
    _this._delete = _this._delete.bind(_assertThisInitialized(_this));
    _this._showDeleteConfirm = _this._showDeleteConfirm.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FooterContainer.prototype;

  _proto._showEdit = function _showEdit(e) {
    e.preventDefault();
    e.stopPropagation();
    var _this$props = this.props,
        block = _this$props.block,
        contentState = _this$props.contentState;
    this.context.showPluginEditor(FOOTER, true, _extends({}, contentState.getEntity(block.getEntityAt(0)).getData(), {
      blockEntityKey: block.getEntityAt(0)
    }));
  };

  _proto._showDeleteConfirm = function _showDeleteConfirm(e) {
    var _this2 = this;

    e.preventDefault();
    e.stopPropagation();
    this.setState({
      showConfirmDelete: true
    });

    if (this.confirmDeleteTimeout) {
      clearTimeout(this.confirmDeleteTimeout);
    }

    this.confirmDeleteTimeout = setTimeout(function () {
      return _this2.setState({
        showConfirmDelete: false
      });
    }, 5000);
  };

  _proto._delete = function _delete(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.confirmDeleteTimeout) {
      clearTimeout(this.confirmDeleteTimeout);
    }

    var _this$props2 = this.props,
        contentState = _this$props2.contentState,
        block = _this$props2.block;
    var _this$context = this.context,
        editorState = _this$context.editorState,
        onChangeEditorState = _this$context.onChangeEditorState;
    onChangeEditorState((0, _Modifiers.deleteBlock)(contentState, editorState, block.getKey()));
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        block = _this$props3.block,
        className = _this$props3.className,
        theme = _this$props3.theme,
        otherProps = _objectWithoutPropertiesLoose(_this$props3, _excluded); // leveraging destructuring to omit certain properties from props


    var blockProps = otherProps.blockProps,
        customStyleMap = otherProps.customStyleMap,
        customStyleFn = otherProps.customStyleFn,
        decorator = otherProps.decorator,
        forceSelection = otherProps.forceSelection,
        offsetKey = otherProps.offsetKey,
        selection = otherProps.selection,
        tree = otherProps.tree,
        contentState = otherProps.contentState,
        blockStyleFn = otherProps.blockStyleFn,
        elementProps = _objectWithoutPropertiesLoose(otherProps, _excluded2);

    var editorTheme = blockProps.editorTheme;

    var _contentState$getEnti = contentState.getEntity(block.getEntityAt(0)).getData(),
        address1 = _contentState$getEnti.address1,
        address2 = _contentState$getEnti.address2,
        twitterUrl = _contentState$getEnti.twitterUrl,
        facebookUrl = _contentState$getEnti.facebookUrl,
        instagramUrl = _contentState$getEnti.instagramUrl,
        linkedinUrl = _contentState$getEnti.linkedinUrl;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "common-block-container email-footer-container"
    }, /*#__PURE__*/_react["default"].createElement("table", {
      style: _extends({}, editorTheme['footer-wrapper'], elementProps)
    }, /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
      style: editorTheme['footer-td']
    }, "Address:", /*#__PURE__*/_react["default"].createElement("br", null), address1 || 'address line 1', /*#__PURE__*/_react["default"].createElement("br", null), address2 || 'address line 2', (twitterUrl || facebookUrl || instagramUrl || linkedinUrl) && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("br", null), "Connect with us:", /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({}, editorTheme['footer-social-media-icon-wrapper'])
    }, facebookUrl && /*#__PURE__*/_react["default"].createElement("a", {
      href: facebookUrl
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({}, editorTheme['footer-social-media-icon'])
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _FooterImages.FacebookImg,
      alt: "facebook",
      width: "100%",
      height: "100%"
    }))), twitterUrl && /*#__PURE__*/_react["default"].createElement("a", {
      href: twitterUrl
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({}, editorTheme['footer-social-media-icon'])
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _FooterImages.TwitterImg,
      alt: "twitter",
      width: "100%",
      height: "100%"
    }))), instagramUrl && /*#__PURE__*/_react["default"].createElement("a", {
      href: instagramUrl
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({}, editorTheme['footer-social-media-icon'])
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _FooterImages.InstagramImg,
      alt: "instagram",
      width: "100%",
      height: "100%"
    }))), linkedinUrl && /*#__PURE__*/_react["default"].createElement("a", {
      href: linkedinUrl
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({}, editorTheme['footer-social-media-icon'])
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _FooterImages.LinkedinImg,
      alt: "linkedin",
      width: "100%",
      height: "100%"
    }))))))))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "edit-options text-right"
    }, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Button, {
      size: "sm",
      variant: "info",
      onClick: this._showEdit
    }, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.IcIcon, {
      icon: _FaICIconMap.faPencilAlt
    })), "\xA0\xA0"));
  };

  return FooterContainer;
}(_react.Component);

exports["default"] = FooterContainer;

_defineProperty(FooterContainer, "contextType", _EditorContext.EditorContext);

module.exports = exports.default;